import React, {Component} from "react";
import {connect} from "react-redux";
import {Route, Switch} from "react-router-dom";

import Report from "./report";
import {
  clearReportData,
  getReport,
} from "../../appRedux/actions/AttendanceManpower";
import {
  faviconDynamicFunction,
  sanitizeFieldName
} from "../../util/methods";
import AccessControl from "../../components/AccessControl";

export class ManpowerAttendance extends Component {
  constructor(props) {
    super(props);
  }

  generateReport = values => {
    this.props.getReport(values);
  };

  render() {
    const {
      match,
      loading,
      filters,
      modules,
      authUser,
      resourceName,
      reportData
    } = this.props;

    faviconDynamicFunction(authUser);

    return (
      <div>
        <h2>{sanitizeFieldName(resourceName)}</h2>

        <Switch>
          <Route
            path={`${match.url}`}
            exact
            render={props => (
              <AccessControl
                resource={'ManpowerAttendance'}
                permissionNeeded={"r"}
                roles={this.props.authUser ? this.props.authUser.roles : []}
                render={props => {
                  return (
                    <Report
                      title={"REPORT"}
                      resource={resourceName}
                      reportData={reportData}
                      generateReport={this.generateReport}
                      clearReportData={this.props.clearReportData}
                      loading={loading}
                      {...props}
                    />
                  );
                }}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = ({auth, manpowerAttendance, commonData}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    reportData: manpowerAttendance.reports,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getReport,
    clearReportData,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps()
)(ManpowerAttendance);
